<app-feature-details-grid>
  <!-- summary gas consumption dhw -->
  <ng-container *ngIf="gasConsumptionSummaryDhw">
    <app-feature-list-container
      title="{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_MODE.DHW' | translate }}"
    >
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_DAY' | translate }}:"
        value="{{ gasConsumptionSummaryDhw | value2: featurePropertyKey.currentDay }} {{
          gasConsumptionSummaryDhw | unit: featurePropertyKey.currentDay
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.LAST_SEVEN_DAYS' | translate }}:"
        value="{{ gasConsumptionSummaryDhw | value2: featurePropertyKey.lastSevenDays }} {{
          gasConsumptionSummaryDhw | unit: featurePropertyKey.lastSevenDays
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_MONTH' | translate }}:"
        value="{{ gasConsumptionSummaryDhw | value2: featurePropertyKey.currentMonth }} {{
          gasConsumptionSummaryDhw | unit: featurePropertyKey.currentMonth
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_YEAR' | translate }}:"
        value="{{ gasConsumptionSummaryDhw | value2: featurePropertyKey.currentYear }} {{
          gasConsumptionSummaryDhw | unit: featurePropertyKey.currentYear
        }}"
      >
      </app-feature-list-item>
    </app-feature-list-container>
  </ng-container>

  <!-- summary gas consumption heating -->
  <ng-container *ngIf="gasConsumptionSummaryHeating">
    <app-feature-list-container title="{{ 'FEATURE.HEATING.GAS.CONSUMPTION.HEATING' | translate }}">
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_DAY' | translate }}:"
        value="{{ gasConsumptionSummaryHeating | value2: featurePropertyKey.currentDay }} {{
          gasConsumptionSummaryHeating | unit: featurePropertyKey.currentDay
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.LAST_SEVEN_DAYS' | translate }}:"
        value="{{ gasConsumptionSummaryHeating | value2: featurePropertyKey.lastSevenDays }} {{
          gasConsumptionSummaryHeating | unit: featurePropertyKey.lastSevenDays
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_MONTH' | translate }}:"
        value="{{ gasConsumptionSummaryHeating | value2: featurePropertyKey.currentMonth }} {{
          gasConsumptionSummaryHeating | unit: featurePropertyKey.currentMonth
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_YEAR' | translate }}:"
        value="{{ gasConsumptionSummaryHeating | value2: featurePropertyKey.currentYear }} {{
          gasConsumptionSummaryHeating | unit: featurePropertyKey.currentYear
        }}"
      >
      </app-feature-list-item>
    </app-feature-list-container>
  </ng-container>
</app-feature-details-grid>
<app-feature-details-grid>
  <!-- summary electricity consumption dhw -->
  <ng-container *ngIf="powerConsumptionSummaryDhw">
    <app-feature-list-container
      title="{{ '+INSTALLATIONS.INSTALLATION.CIRCUIT.HEATING_MODE.DHW' | translate }}"
    >
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_DAY' | translate }}:"
        value="{{ powerConsumptionSummaryDhw | value2: featurePropertyKey.currentDay }} {{
          powerConsumptionSummaryDhw | unit: featurePropertyKey.currentDay
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.LAST_SEVEN_DAYS' | translate }}:"
        value="{{ powerConsumptionSummaryDhw | value2: featurePropertyKey.lastSevenDays }} {{
          powerConsumptionSummaryDhw | unit: featurePropertyKey.lastSevenDays
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_MONTH' | translate }}:"
        value="{{ powerConsumptionSummaryDhw | value2: featurePropertyKey.currentMonth }} {{
          powerConsumptionSummaryDhw | unit: featurePropertyKey.currentMonth
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_YEAR' | translate }}:"
        value="{{ powerConsumptionSummaryDhw | value2: featurePropertyKey.currentYear }} {{
          powerConsumptionSummaryDhw | unit: featurePropertyKey.currentYear
        }}"
      >
      </app-feature-list-item>
    </app-feature-list-container>
  </ng-container>

  <!-- summary electricity consumption heating -->
  <ng-container *ngIf="powerConsumptionSummaryHeating">
    <app-feature-list-container title="{{ 'FEATURE.HEATING.GAS.CONSUMPTION.HEATING' | translate }}">
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_DAY' | translate }}:"
        value="{{ powerConsumptionSummaryHeating | value2: featurePropertyKey.currentDay }} {{
          powerConsumptionSummaryHeating | unit: featurePropertyKey.currentDay
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.LAST_SEVEN_DAYS' | translate }}:"
        value="{{ powerConsumptionSummaryHeating | value2: featurePropertyKey.lastSevenDays }} {{
          powerConsumptionSummaryHeating | unit: featurePropertyKey.lastSevenDays
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_MONTH' | translate }}:"
        value="{{ powerConsumptionSummaryHeating | value2: featurePropertyKey.currentMonth }} {{
          powerConsumptionSummaryHeating | unit: featurePropertyKey.currentMonth
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_YEAR' | translate }}:"
        value="{{ powerConsumptionSummaryHeating | value2: featurePropertyKey.currentYear }} {{
          powerConsumptionSummaryHeating | unit: featurePropertyKey.currentYear
        }}"
      >
      </app-feature-list-item>
    </app-feature-list-container>
  </ng-container>

  <!-- summary autarky -->
  <ng-container *ngIf="autarkySummary">
    <app-feature-list-container title="{{ '+INSTALLATIONS.INSTALLATION.AUTARKY' | translate }}">
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_DAY' | translate }}:"
        value="{{ autarkySummary | value2: featurePropertyKey.current }} {{
          autarkySummary | unit: featurePropertyKey.current
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.LAST_SEVEN_DAYS' | translate }}:"
        value="{{ autarkySummary | value2: featurePropertyKey.lastSevenDays }} {{
          autarkySummary | unit: featurePropertyKey.lastSevenDays
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_MONTH' | translate }}"
        value="{{ autarkySummary | value2: featurePropertyKey.currentMonth }} {{
          autarkySummary | unit: featurePropertyKey.currentMonth
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.LAST_MONTH' | translate }}:"
        value="{{ autarkySummary | value2: featurePropertyKey.lastMonth }} {{
          autarkySummary | unit: featurePropertyKey.lastMonth
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_YEAR' | translate }}:"
        value="{{ autarkySummary | value2: featurePropertyKey.currentYear }} {{
          autarkySummary | unit: featurePropertyKey.currentYear
        }}"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.LAST_YEAR' | translate }}:"
        value="{{ autarkySummary | value2: featurePropertyKey.lastYear }} {{
          autarkySummary | unit: featurePropertyKey.lastYear
        }}"
      >
      </app-feature-list-item>
    </app-feature-list-container>
  </ng-container>
</app-feature-details-grid>
